import styled from "styled-components";
import { colors, font, radius } from "../../../styles/theme/tokens";


export const Wrapper = styled.div`
   
   display: flex;
   height: 100vh;

`

// Перемикач мови кабінету (англійська / іспанська) — над кожною сторінкою адмінки
export const LangBar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  padding: 12px 16px 0;
`;

export const LangBtn = styled.button`
  padding: 8px 16px;
  border-radius: ${radius.pill};
  border: 1px solid ${(props) => (props.$active ? colors.brand : colors.line)};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 800;
  color: ${(props) => (props.$active ? "#FFFFFF" : colors.ink)};
  background: ${(props) => (props.$active ? colors.brand : colors.surface)};
  cursor: pointer;
`;
